// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-aa1607f6] .fcr-hx-send-btn {\n  bottom: 25px;\n}\n[data-v-aa1607f6] .scenes-controller-container {\n  bottom: 30px;\n}\n#interviewRoom[data-v-aa1607f6] {\n  position: absolute;\n  width: 108%;\n  overflow: hidden;\n  height: calc(100vh - 82px);\n  /*no*/\n}\n#interviewRoom .btn[data-v-aa1607f6] {\n  line-height: 0.5rem !important;\n}\n", ""]);
// Exports
module.exports = exports;
